<ion-list mode="ios" lines="none" class="list-content info-sheet-modal-content">
  <!-- ? Header con icono y título -->
  <ion-item mode="md" lines="none" class="info-sheet-modal-header">
    <ng-container *ngIf="config?.icon">
      <ion-buttons slot="start">
        <ion-button shape="round" mode="ios" class="button-icon" disabled>
          <app-icon-getm
            [name]="config.icon"
            [variant]="'outline'"
            [size]="'s'"
            [color]="'var(--color-blue-gepp-60)'"
          ></app-icon-getm>
        </ion-button>
      </ion-buttons>
    </ng-container>

    <ion-label class="info-sheet-modal-title"> {{ config?.title }} </ion-label>

    <ion-buttons slot="end">
      <ng-container *ngIf="config?.showCloseButton !== false">
        <ion-button
          shape="round"
          mode="ios"
          class="button-close"
          (click)="onClose()"
        >
          <app-icon-getm
            [name]="'close'"
            [size]="'s'"
            [color]="'var(--color-blue-gray-80)'"
          ></app-icon-getm>
        </ion-button>
      </ng-container>
    </ion-buttons>
  </ion-item>

  <!-- ? Contenido del modal: componente dinámico o content legacy -->
  <ion-item
    *ngIf="config?.component; else contentTemplate"
    lines="none"
    class="info-sheet-modal-body"
  >
    <ng-container *ngComponentOutlet="config.component"></ng-container>
  </ion-item>

  <ng-template #contentTemplate>
    <ion-item lines="none" class="info-sheet-modal-body">
      <ion-label
        [innerHTML]="config?.content | htmlSeguro"
        class="text-content"
      ></ion-label>
    </ion-item>
  </ng-template>

  <!-- ? Footer con botón de cerrar -->
  <ion-item mode="md" lines="none" class="info-sheet-modal-footer">
    <app-button-getm
      type="white"
      size="medium"
      [expand]="true"
      [fill]="'outline'"
      (buttonClick)="onClose()"
    >
      {{ config?.closeButtonText }}
    </app-button-getm>
  </ion-item>
</ion-list>
